webpackJsonp([57714563526443],{

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 1: Install the CLI'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Before you can use Lore, you will need to install Node. If you don\'t have it installed, see ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../misc/installing-node/' },
	        'these instructions'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Install Lore'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To get started with Lore, first install the CLI (Command Line Interface) from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ npm install -g lore-cli\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the CLI is installed, you will have access to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore'
	      ),
	      ' from the command line. Run ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore'
	      ),
	      ' to see a list of available commands:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ lore\n\n      Usage: $ <command>\n\n      Commands:\n      new       Create a new application\n      extract   Create files that mirror the blueprint behavior\n      generate  Generate common project files\n\n\n      Options:\n      --version  Show version number                                       [boolean]\n      --help     Show help                                                 [boolean]\n\n      Please enter a valid command.\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now that the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-cli'
	      ),
	      ' is installed, let\'s ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/quickstart/setup/step-2/' },
	        'create a new application'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-setup-step-1-js-73a6c818df37674d426e.js